<template>
  <div>
    <filter-box
      :hideOperate="true"
      :inline="inline"
      :labelWidth="labelWidth"
      :formConfig="formConfig"
      :form="filterObj"
      ref="filterBox"
    >
      <div slot="footer">
        <slot name="footer"></slot>
      </div>
    </filter-box>
    <element-table
      ref="table"
      size="mini"
      :data="data"
      :columns="columns"
      :loading="loading"
      :maxHeight="height ? height : 400"
      border
      :expandAll="expandAll"
      @on-current-change="currentChange"
      @on-selection-change="selectionChange"
      @on-sort-change="handleSortChange"
    ></element-table>
    <el-pagination
      ref="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-sizes="pagesize"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.totalCount"
      style="margin-top: 20px"
      class="table-pagination"
    >
    </el-pagination>
  </div>
</template>

<script>
import FilterBox from "@/components/filter-box";
import ElementTable from "@/components/ElementTable";
export default {
  props: {
    filterObj: Object,
    formConfig: Array,
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    inline: Boolean,
    labelWidth: {
      type: String
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => {
        return [];
      }
    },
    expandAll: Boolean,
    height: Number
  },
  inject: {
    handleSizeChange: {
      from: "handleSizeChange",
      default: () => {
        return () => {};
      }
    },
    handleCurrentChange: {
      from: "handleCurrentChange",
      default: () => {
        return () => {};
      }
    }
  },
  data() {
    return {
      pagesize: [2, 10, 20, 50, 100]
    };
  },
  components: {
    ElementTable,
    FilterBox
  },
  methods: {
    selectionChange(params) {
      this.$emit("on-selection-change", params);
    },
    handleSortChange(params) {
      this.$emit("on-sort-change", params);
    },
    toggleRowSelection(row) {
      this.$refs.table.toggleRowSelection(row);
    },
    doLayout(row) {
      this.$refs.table.doLayout();
    },
    currentChange(params) {
      this.$emit("on-current-change", params);
    }
  }
};
</script>

<style lang="scss">
.table-pagination {
  text-align: right;
  .el-pagination__total {
    float: left;
  }
  .el-pagination__sizes {
    float: left;
  }
}
</style>
